// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modal Overlay */
.kLlB3Q {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  justify-content: flex-end;
  align-items: stretch;
}

/* Drawer Container */
._2xHrS {
  width: 400px;
  max-height: 100vh;
  background-color: var(--background-white);
  display: flex;
  flex-direction: column;
  gap: 1px;
  box-shadow: var(--shadow-card);
  animation: Fzid7e var(--transition-normal) ease-out;
  overflow: hidden;
}

/* Animation */
@keyframes Fzid7e {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}

/* Header */
.PTVD69 {
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
  padding: var(--spacing-3) 14px 0px;
  flex: none;
  align-self: stretch;
  justify-content: space-between;
}

.hiHGMq {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: var(--spacing-1);
  padding: 0;
  background: none;
  border: none;
  border-radius: var(--radius-s);
  min-width: auto;
  height: auto;
  cursor: pointer;
}

.hiHGMq svg {
  width: var(--spacing-2);
  height: var(--spacing-2);
  color: var(--text-neutral-stronger);
}

.uLHflG {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: var(--spacing-1);
  padding: 0;
  background: none;
  border: none;
  border-radius: var(--radius-s);
  min-width: auto;
  height: auto;
  cursor: pointer;
}

.uLHflG svg {
  width: var(--spacing-2);
  height: var(--spacing-2);
  color: var(--text-neutral-stronger);
}

.MuX8K8 {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-xl);
  line-height: 1.424;
  color: var(--text-neutral-dark);
  margin: 0;
  text-align: left;
  flex: 1;
}

/* Content */
.Mqa6h4 {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
  padding: var(--spacing-3);
  flex: 1;
  align-self: stretch;
  overflow-y: auto;
  min-height: 0;
}

/* Section */
.d7qwJ5 {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2);
  align-self: stretch;
}

/* Amount Container */
.OSQlES {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-0-5);
  align-self: stretch;
}

.cl8iaC {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  line-height: var(--line-height-180);
  color: var(--text-neutral-dark);
  text-align: left;
}

.lUqISs {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-xl);
  line-height: 1.424;
  color: var(--text-neutral-dark);
  text-align: left;
}

/* Divider */
.NJNfqu {
  height: 1px;
  background-color: var(--surface-neutral-subtle);
  align-self: stretch;
  margin: 0;
}

/* Details Container */
.suxNpx {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2);
  align-self: stretch;
}

.RxSZ26 {
  display: flex;
  justify-content: stretch;
  align-items: stretch;
  gap: var(--spacing-3);
  align-self: stretch;
}

.rFngmN {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  line-height: var(--line-height-180);
  color: var(--text-neutral-dark);
  text-align: left;
  flex: 1;
}

.rKjeVF {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-md);
  line-height: var(--line-height-180);
  color: var(--text-neutral-dark);
  text-align: left;
  flex: 1;
}

/* Fields Container */
.YwzfAH {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: var(--spacing-1);
  align-self: stretch;
}

.klcXXA {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-self: stretch;
}

.tX5jXT {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  line-height: 1.421;
  color: var(--text-neutral-dark);
  text-align: left;
  margin-bottom: var(--spacing-0-5);
}

.LYmZ3x {
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
  padding: var(--spacing-1-5);
  background-color: var(--surface-neutral-pale);
  border: 1px solid var(--surface-neutral-silver);
  border-radius: var(--radius-s);
  align-self: stretch;
}

.yQQs1d {
  flex: 1;
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  line-height: var(--line-height-180);
  color: var(--text-neutral-dark);
  word-break: break-all;
  text-align: left;
}

.K9GzwT {
  width: var(--spacing-2);
  height: var(--spacing-2);
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  flex-shrink: 0;
}

.K9GzwT svg {
  width: var(--spacing-2);
  height: var(--spacing-2);
  color: var(--text-neutral-stronger);
}

/* QR Code Section */
.MUq5zf {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1-5);
  align-self: stretch;
}

.Yen6tD {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1-5);
  width: fit-content;
  margin: 0;
  align-items: flex-start;
}

.IALspI {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--spacing-1);
  align-self: stretch;
  width: 100%;
  min-width: 160px;
}

.FMGcGr {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-lg);
  line-height: 1.424;
  color: var(--text-neutral-dark);
  text-align: left;
  margin: 0;
}

.UyB2ys {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: var(--spacing-1);
  height: 24px;
  padding: 0;
  background: none;
  border: none;
  border-radius: var(--radius-s);
  cursor: pointer;
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  color: var(--brand-tr-orange);
  width: auto;
  flex-shrink: 0;
}

.lNeSEp {
  width: 14px;
  height: 14px;
  color: var(--brand-tr-orange);
}

.ybTyuN {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 160px;
  height: 160px;
  border-radius: var(--radius-s);
  background-color: var(--background-white);
}

/* QR Code SVG styling */
.ybTyuN svg {
  width: 160px !important;
  height: 160px !important;
}

.JnKBKL {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: var(--text-neutral-strong);
  font-size: 48px;
  background-color: #f0f0f0;
  text-align: center;
  gap: var(--spacing-1);
}

.skTE4u {
  font-family: var(--font-family-base);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-regular);
  color: var(--text-neutral-strong);
  text-align: center;
  margin-top: var(--spacing-1);
}

/* Footer */
.TYC7iS {
  display: flex;
  justify-content: stretch;
  align-items: stretch;
  gap: var(--spacing-2);
  padding: var(--spacing-3);
  align-self: stretch;
  flex-shrink: 0;
  border-top: 1px solid var(--surface-neutral-subtle);
}

.IWGGCX {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: var(--spacing-1);
  padding: var(--spacing-1) var(--spacing-1-5);
  flex: 1;
  background-color: var(--brand-tr-orange);
  border: none;
  border-radius: var(--radius-s);
  cursor: pointer;
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-md);
  line-height: 1.424;
  color: var(--background-white);
  text-align: center;
}

/* Responsive Design */
@media (max-width: var(--grid-breakpoint-xs)) {
  .kLlB3Q {
    justify-content: stretch;
  }

  ._2xHrS {
    width: 100%;
    max-width: 100vw;
  }

  .PTVD69 {
    padding: var(--spacing-2) var(--spacing-1) 0;
  }

  .Mqa6h4 {
    padding: var(--spacing-2);
  }

  .TYC7iS {
    padding: var(--spacing-2);
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/pagamentos/src/components/ChargesDetailsModal/ChargesDetailsModal.module.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,aAAa;EACb,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA,qBAAqB;AACrB;EACE,YAAY;EACZ,iBAAiB;EACjB,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,8BAA8B;EAC9B,mDAAoD;EACpD,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,kCAAkC;EAClC,UAAU;EACV,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,8BAA8B;EAC9B,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,8BAA8B;EAC9B,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,kBAAkB;EAClB,+BAA+B;EAC/B,SAAS;EACT,gBAAgB;EAChB,OAAO;AACT;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;EACzB,OAAO;EACP,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;AACf;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,WAAW;EACX,+CAA+C;EAC/C,mBAAmB;EACnB,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;EAC/B,gBAAgB;EAChB,OAAO;AACT;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;EAC/B,gBAAgB;EAChB,OAAO;AACT;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,6CAA6C;EAC7C,+CAA+C;EAC/C,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;EAC/B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,mCAAmC;AACrC;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,8BAA8B;EAC9B,eAAe;EACf,oCAAoC;EACpC,8BAA8B;EAC9B,6BAA6B;EAC7B,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,yCAAyC;AAC3C;;AAEA,wBAAwB;AACxB;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,iCAAiC;EACjC,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,WAAW;AACX;EACE,aAAa;EACb,wBAAwB;EACxB,oBAAoB;EACpB,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,mDAAmD;AACrD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,4CAA4C;EAC5C,OAAO;EACP,wCAAwC;EACxC,YAAY;EACZ,8BAA8B;EAC9B,eAAe;EACf,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,kBAAkB;EAClB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,4CAA4C;EAC9C;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["/* Modal Overlay */\n.overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 9999;\n  display: flex;\n  justify-content: flex-end;\n  align-items: stretch;\n}\n\n/* Drawer Container */\n.drawer {\n  width: 400px;\n  max-height: 100vh;\n  background-color: var(--background-white);\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  box-shadow: var(--shadow-card);\n  animation: slideIn var(--transition-normal) ease-out;\n  overflow: hidden;\n}\n\n/* Animation */\n@keyframes slideIn {\n  from {\n    transform: translateX(100%);\n  }\n  to {\n    transform: translateX(0);\n  }\n}\n\n/* Header */\n.header {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1);\n  padding: var(--spacing-3) 14px 0px;\n  flex: none;\n  align-self: stretch;\n  justify-content: space-between;\n}\n\n.backButton {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: var(--spacing-1);\n  padding: 0;\n  background: none;\n  border: none;\n  border-radius: var(--radius-s);\n  min-width: auto;\n  height: auto;\n  cursor: pointer;\n}\n\n.backButton svg {\n  width: var(--spacing-2);\n  height: var(--spacing-2);\n  color: var(--text-neutral-stronger);\n}\n\n.closeButton {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: var(--spacing-1);\n  padding: 0;\n  background: none;\n  border: none;\n  border-radius: var(--radius-s);\n  min-width: auto;\n  height: auto;\n  cursor: pointer;\n}\n\n.closeButton svg {\n  width: var(--spacing-2);\n  height: var(--spacing-2);\n  color: var(--text-neutral-stronger);\n}\n\n.title {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-xl);\n  line-height: 1.424;\n  color: var(--text-neutral-dark);\n  margin: 0;\n  text-align: left;\n  flex: 1;\n}\n\n/* Content */\n.content {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3);\n  padding: var(--spacing-3);\n  flex: 1;\n  align-self: stretch;\n  overflow-y: auto;\n  min-height: 0;\n}\n\n/* Section */\n.section {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-2);\n  align-self: stretch;\n}\n\n/* Amount Container */\n.amountContainer {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-0-5);\n  align-self: stretch;\n}\n\n.amountLabel {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-180);\n  color: var(--text-neutral-dark);\n  text-align: left;\n}\n\n.amountValue {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-xl);\n  line-height: 1.424;\n  color: var(--text-neutral-dark);\n  text-align: left;\n}\n\n/* Divider */\n.divider {\n  height: 1px;\n  background-color: var(--surface-neutral-subtle);\n  align-self: stretch;\n  margin: 0;\n}\n\n/* Details Container */\n.detailsContainer {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-2);\n  align-self: stretch;\n}\n\n.detailRow {\n  display: flex;\n  justify-content: stretch;\n  align-items: stretch;\n  gap: var(--spacing-3);\n  align-self: stretch;\n}\n\n.detailLabel {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-180);\n  color: var(--text-neutral-dark);\n  text-align: left;\n  flex: 1;\n}\n\n.detailValue {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-180);\n  color: var(--text-neutral-dark);\n  text-align: left;\n  flex: 1;\n}\n\n/* Fields Container */\n.fieldsContainer {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: var(--spacing-1);\n  align-self: stretch;\n}\n\n.field {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-self: stretch;\n}\n\n.fieldLabel {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  line-height: 1.421;\n  color: var(--text-neutral-dark);\n  text-align: left;\n  margin-bottom: var(--spacing-0-5);\n}\n\n.fieldContainer {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1);\n  padding: var(--spacing-1-5);\n  background-color: var(--surface-neutral-pale);\n  border: 1px solid var(--surface-neutral-silver);\n  border-radius: var(--radius-s);\n  align-self: stretch;\n}\n\n.fieldValue {\n  flex: 1;\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-180);\n  color: var(--text-neutral-dark);\n  word-break: break-all;\n  text-align: left;\n}\n\n.copyButton {\n  width: var(--spacing-2);\n  height: var(--spacing-2);\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: none;\n  border: none;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.copyButton svg {\n  width: var(--spacing-2);\n  height: var(--spacing-2);\n  color: var(--text-neutral-stronger);\n}\n\n/* QR Code Section */\n.qrContainer {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1-5);\n  align-self: stretch;\n}\n\n.qrGroup {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1-5);\n  width: fit-content;\n  margin: 0;\n  align-items: flex-start;\n}\n\n.qrHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: var(--spacing-1);\n  align-self: stretch;\n  width: 100%;\n  min-width: 160px;\n}\n\n.qrTitle {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-lg);\n  line-height: 1.424;\n  color: var(--text-neutral-dark);\n  text-align: left;\n  margin: 0;\n}\n\n.downloadPdfButton {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: var(--spacing-1);\n  height: 24px;\n  padding: 0;\n  background: none;\n  border: none;\n  border-radius: var(--radius-s);\n  cursor: pointer;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  color: var(--brand-tr-orange);\n  width: auto;\n  flex-shrink: 0;\n}\n\n.downloadIcon {\n  width: 14px;\n  height: 14px;\n  color: var(--brand-tr-orange);\n}\n\n.qrCode {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 160px;\n  height: 160px;\n  border-radius: var(--radius-s);\n  background-color: var(--background-white);\n}\n\n/* QR Code SVG styling */\n.qrCode svg {\n  width: 160px !important;\n  height: 160px !important;\n}\n\n.qrPlaceholder {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  color: var(--text-neutral-strong);\n  font-size: 48px;\n  background-color: #f0f0f0;\n  text-align: center;\n  gap: var(--spacing-1);\n}\n\n.qrPlaceholderText {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-regular);\n  color: var(--text-neutral-strong);\n  text-align: center;\n  margin-top: var(--spacing-1);\n}\n\n/* Footer */\n.footer {\n  display: flex;\n  justify-content: stretch;\n  align-items: stretch;\n  gap: var(--spacing-2);\n  padding: var(--spacing-3);\n  align-self: stretch;\n  flex-shrink: 0;\n  border-top: 1px solid var(--surface-neutral-subtle);\n}\n\n.downloadSlipButton {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: var(--spacing-1);\n  padding: var(--spacing-1) var(--spacing-1-5);\n  flex: 1;\n  background-color: var(--brand-tr-orange);\n  border: none;\n  border-radius: var(--radius-s);\n  cursor: pointer;\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-md);\n  line-height: 1.424;\n  color: var(--background-white);\n  text-align: center;\n}\n\n/* Responsive Design */\n@media (max-width: var(--grid-breakpoint-xs)) {\n  .overlay {\n    justify-content: stretch;\n  }\n\n  .drawer {\n    width: 100%;\n    max-width: 100vw;\n  }\n\n  .header {\n    padding: var(--spacing-2) var(--spacing-1) 0;\n  }\n\n  .content {\n    padding: var(--spacing-2);\n  }\n\n  .footer {\n    padding: var(--spacing-2);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `kLlB3Q`,
	"drawer": `_2xHrS`,
	"slideIn": `Fzid7e`,
	"header": `PTVD69`,
	"backButton": `hiHGMq`,
	"closeButton": `uLHflG`,
	"title": `MuX8K8`,
	"content": `Mqa6h4`,
	"section": `d7qwJ5`,
	"amountContainer": `OSQlES`,
	"amountLabel": `cl8iaC`,
	"amountValue": `lUqISs`,
	"divider": `NJNfqu`,
	"detailsContainer": `suxNpx`,
	"detailRow": `RxSZ26`,
	"detailLabel": `rFngmN`,
	"detailValue": `rKjeVF`,
	"fieldsContainer": `YwzfAH`,
	"field": `klcXXA`,
	"fieldLabel": `tX5jXT`,
	"fieldContainer": `LYmZ3x`,
	"fieldValue": `yQQs1d`,
	"copyButton": `K9GzwT`,
	"qrContainer": `MUq5zf`,
	"qrGroup": `Yen6tD`,
	"qrHeader": `IALspI`,
	"qrTitle": `FMGcGr`,
	"downloadPdfButton": `UyB2ys`,
	"downloadIcon": `lNeSEp`,
	"qrCode": `ybTyuN`,
	"qrPlaceholder": `JnKBKL`,
	"qrPlaceholderText": `skTE4u`,
	"footer": `TYC7iS`,
	"downloadSlipButton": `IWGGCX`
};
module.exports = ___CSS_LOADER_EXPORT___;
